import { render, staticRenderFns } from "./Pxcard.vue?vue&type=template&id=7cced21d"
import script from "./Pxcard.vue?vue&type=script&lang=js"
export * from "./Pxcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports